import React from "react";
import Field from "../../sections/shared/Field";
import EditorGroup from "../../sections/shared/EditorGroup";

export default function FeaturesDesignSection({
  editedSection,
  t,
  flags,
  onStyleChange,
}) {
  const { isFeatures } = flags;

  const templateKey = String(editedSection?.template || "").toLowerCase().trim();

  const isFeaturesTemplate1 =
    isFeatures &&
    (templateKey === "1" || templateKey === "template1" || templateKey.endsWith("template1"));

  const isFeaturesTemplate2 =
    isFeatures &&
    (templateKey === "2" || templateKey === "template2" || templateKey.endsWith("template2"));

  const isFeaturesTemplate3 =
    isFeatures &&
    (templateKey === "3" || templateKey === "template3" || templateKey.endsWith("template3"));

  if (!isFeaturesTemplate1 && !isFeaturesTemplate2 && !isFeaturesTemplate3) return null;

  return (
    <>
      {isFeaturesTemplate1 && (
        <EditorGroup
          title={t("sectionModal.featuresTemplate1.title", "Features Template 1")}
          subtitle={t(
            "sectionModal.featuresTemplate1.help",
            "Customize the feature cards for Features Template 1"
          )}
          defaultOpen={false}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              label={t("sectionModal.featuresTemplate1.cardBg", "Card Background")}
              type="color"
              value={editedSection?.style?.featuresCardBg}
              onChange={(v) => onStyleChange("featuresCardBg", v)}
            />
            <Field
              label={t("sectionModal.featuresTemplate1.cardBorder", "Card Border")}
              type="color"
              value={editedSection?.style?.featuresCardBorder}
              onChange={(v) => onStyleChange("featuresCardBorder", v)}
            />
            <Field
              label={t("sectionModal.featuresTemplate1.titleColor", "Card Title Color")}
              type="color"
              value={editedSection?.style?.featuresCardTitleColor}
              onChange={(v) => onStyleChange("featuresCardTitleColor", v)}
            />
            <Field
              label={t(
                "sectionModal.featuresTemplate1.descriptionColor",
                "Card Description Color"
              )}
              type="color"
              value={editedSection?.style?.featuresCardDescriptionColor}
              onChange={(v) => onStyleChange("featuresCardDescriptionColor", v)}
            />
          </div>
        </EditorGroup>
      )}

      {isFeaturesTemplate2 && (
        <EditorGroup
          title={t("sectionModal.featuresTemplate2.title", "Features Template 2")}
          subtitle={t(
            "sectionModal.featuresTemplate2.help",
            "Customize the badge, cards, and bottom CTA for Features Template 2"
          )}
          defaultOpen={false}
        >
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Field
                label={t("sectionModal.featuresTemplate2.badgeBg", "Badge Background")}
                type="color"
                value={editedSection?.style?.featuresBadgeBg}
                onChange={(v) => onStyleChange("featuresBadgeBg", v)}
              />
              <Field
                label={t("sectionModal.featuresTemplate2.badgeTextColor", "Badge Text Color")}
                type="color"
                value={editedSection?.style?.featuresBadgeTextColor}
                onChange={(v) => onStyleChange("featuresBadgeTextColor", v)}
              />
              <Field
                label={t("sectionModal.featuresTemplate2.badgeBorder", "Badge Border")}
                type="color"
                value={editedSection?.style?.featuresBadgeBorder}
                onChange={(v) => onStyleChange("featuresBadgeBorder", v)}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Field
                label={t("sectionModal.featuresTemplate2.cardBg", "Card Background")}
                type="color"
                value={editedSection?.style?.featuresCardBg2}
                onChange={(v) => onStyleChange("featuresCardBg2", v)}
              />
              <Field
                label={t("sectionModal.featuresTemplate2.cardBorder", "Card Border")}
                type="color"
                value={editedSection?.style?.featuresCardBorder2}
                onChange={(v) => onStyleChange("featuresCardBorder2", v)}
              />
              <Field
                label={t("sectionModal.featuresTemplate2.titleColor", "Card Title Color")}
                type="color"
                value={editedSection?.style?.featuresCardTitleColor2}
                onChange={(v) => onStyleChange("featuresCardTitleColor2", v)}
              />
              <Field
                label={t(
                  "sectionModal.featuresTemplate2.descriptionColor",
                  "Card Description Color"
                )}
                type="color"
                value={editedSection?.style?.featuresCardDescriptionColor2}
                onChange={(v) => onStyleChange("featuresCardDescriptionColor2", v)}
              />
              <Field
                label={t("sectionModal.featuresTemplate2.benefitColor", "Benefit Text Color")}
                type="color"
                value={editedSection?.style?.featuresBenefitColor2}
                onChange={(v) => onStyleChange("featuresBenefitColor2", v)}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Field
                label={t("sectionModal.featuresTemplate2.ctaFrom", "Bottom CTA From")}
                type="color"
                value={editedSection?.style?.featuresBottomCtaBgFrom}
                onChange={(v) => onStyleChange("featuresBottomCtaBgFrom", v)}
              />
              <Field
                label={t("sectionModal.featuresTemplate2.ctaTo", "Bottom CTA To")}
                type="color"
                value={editedSection?.style?.featuresBottomCtaBgTo}
                onChange={(v) => onStyleChange("featuresBottomCtaBgTo", v)}
              />
              <Field
                label={t(
                  "sectionModal.featuresTemplate2.ctaTitleColor",
                  "Bottom CTA Title Color"
                )}
                type="color"
                value={editedSection?.style?.featuresBottomCtaTitleColor}
                onChange={(v) => onStyleChange("featuresBottomCtaTitleColor", v)}
              />
              <Field
                label={t(
                  "sectionModal.featuresTemplate2.ctaSubtitleColor",
                  "Bottom CTA Subtitle Color"
                )}
                type="color"
                value={editedSection?.style?.featuresBottomCtaSubtitleColor}
                onChange={(v) => onStyleChange("featuresBottomCtaSubtitleColor", v)}
              />
            </div>
          </div>
        </EditorGroup>
      )}

      {isFeaturesTemplate3 && (
        <EditorGroup
          title={t("sectionModal.featuresTemplate3.title", "Features Template 3")}
          subtitle={t(
            "sectionModal.featuresTemplate3.help",
            "Customize the left feature list and floating badge for Features Template 3"
          )}
          defaultOpen={false}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              label={t("sectionModal.featuresTemplate3.activeBg", "Active Item Background")}
              type="color"
              value={editedSection?.style?.featuresTabActiveBg}
              onChange={(v) => onStyleChange("featuresTabActiveBg", v)}
            />
            <Field
              label={t("sectionModal.featuresTemplate3.activeBorder", "Active Item Border")}
              type="color"
              value={editedSection?.style?.featuresTabActiveBorder}
              onChange={(v) => onStyleChange("featuresTabActiveBorder", v)}
            />
            <Field
              label={t("sectionModal.featuresTemplate3.inactiveBg", "Inactive Item Background")}
              type="color"
              value={editedSection?.style?.featuresTabInactiveBg}
              onChange={(v) => onStyleChange("featuresTabInactiveBg", v)}
            />
            <Field
              label={t("sectionModal.featuresTemplate3.tabTitleColor", "Item Title Color")}
              type="color"
              value={editedSection?.style?.featuresTabTitleColor}
              onChange={(v) => onStyleChange("featuresTabTitleColor", v)}
            />
            <Field
              label={t(
                "sectionModal.featuresTemplate3.tabDescriptionColor",
                "Item Description Color"
              )}
              type="color"
              value={editedSection?.style?.featuresTabDescriptionColor}
              onChange={(v) => onStyleChange("featuresTabDescriptionColor", v)}
            />
            <Field
              label={t(
                "sectionModal.featuresTemplate3.badgeBg",
                "Floating Badge Background"
              )}
              type="color"
              value={editedSection?.style?.featuresFloatingBadgeBg}
              onChange={(v) => onStyleChange("featuresFloatingBadgeBg", v)}
            />
            <Field
              label={t(
                "sectionModal.featuresTemplate3.badgeTitleColor",
                "Floating Badge Title Color"
              )}
              type="color"
              value={editedSection?.style?.featuresFloatingBadgeTitleColor}
              onChange={(v) => onStyleChange("featuresFloatingBadgeTitleColor", v)}
            />
            <Field
              label={t(
                "sectionModal.featuresTemplate3.badgeSubtitleColor",
                "Floating Badge Subtitle Color"
              )}
              type="color"
              value={editedSection?.style?.featuresFloatingBadgeSubtitleColor}
              onChange={(v) => onStyleChange("featuresFloatingBadgeSubtitleColor", v)}
            />
          </div>
        </EditorGroup>
      )}
    </>
  );
}